<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="header-container">
  <h1 id="header-text">{{ titleText }}</h1>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="select-button" class="action-button"
            (click)="onSubmit()" [disabled]="selectedScenarios === null || selectedScenarios.length === 0">
      Select
    </button>
  </div>
</div>
<div class="set-height">
  <app-vehicle-scenario-select
    [titleText]="titleText"
    [validFcorgs]="validFcorgs"
    [isMultiSelect]="isMultiSelect"
    (confirmEvent)="onSelectEvent($event)">
  </app-vehicle-scenario-select>

</div>
